import Papa, { ParseResult } from 'papaparse';
import { createEmployee, FetchAlljobLocation, getEmployees, updateBankDetails } from '../core/data/redux/employee/employeeAction';
import { AppDispatch } from '../core/data/redux/store';
import { useDispatch, useSelector } from 'react-redux';
import { message } from 'antd';
import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import { fetchAllDepartments } from '../core/data/redux/department/departmentAction';
import { fetchAllDesignations } from '../core/data/redux/designation/designationAction';
import { fetchAllBranch } from '../core/data/redux/branch/branch.Action';
import { fetchAllLeaveTypes } from '../core/data/redux/attendance/leaveTypes/LeaveTypeActions';
import { fetchingexperience } from '../core/data/redux/experience/experience.Action';

export const useEmployeeCSVImport = (setTableKey: React.Dispatch<React.SetStateAction<number>>) => {
    const dispatch = useDispatch<AppDispatch>();
    const { user } = useSelector((state: any) => state.auth);
    const { departments } = useSelector((state: any) => state.department);
    const { designations } = useSelector((state: any) => state.designation);
    const { roles } = useSelector((state: any) => state.role);
    const { employees } = useSelector((state: any) => state.employee);
    const { branch } = useSelector((state: any) => state.branch);
    const [joblocation, setjoblocation] = useState<any>([]);
    const [experience, setexperience] = useState([]);
    useEffect(() => {
        dispatch(fetchAllDepartments());
        dispatch(fetchAllDesignations());
        dispatch(fetchAllBranch());
        dispatch(FetchAlljobLocation()).then((res) => {
            setjoblocation(res.payload.data);
        });
        dispatch(fetchAllLeaveTypes());
        dispatch(fetchingexperience()).then((res) => {
            setexperience(res.payload.data);
        });
        dispatch(getEmployees());
    }, []);

    const handleCSVImport = (file: File) => {
        message.loading({ content: 'Importing employees...', key: 'import' });
        Papa.parse(file, {
            header: true,
            skipEmptyLines: true,
            complete: async function (results: ParseResult<any>) {
                const records = results.data as any[];
                let validCount = 0;
                let invalidCount = 0;

                for (let row of records) {
                    const validationErrors = [];

                    // --- Convert Name Fields to IDs (with null-safe lookups) ---
                    const designationObj = designations?.find(
                        (d: any) => d?.DesignationName?.trim().toLowerCase() === (row.designation || '').trim().toLowerCase()
                    );

                    const departmentObj = departments?.find(
                        (d: any) => d?.Name?.toLowerCase() === row.department?.toLowerCase()
                    );

                    const roleObj = roles?.find(
                        (r: any) => r?.RoleName?.trim().toLowerCase() === (row.employeeRole || '').trim().toLowerCase()
                    );


                    const branchObj = branch?.find(
                        (b: any) => b?.Branch_Name?.trim().toLowerCase() === (row.branch || '').trim().toLowerCase()
                    );


                    const normalize = (str: string) =>
                        (str || '').replace(/\s+/g, ' ').trim().toLowerCase();

                    const managerObj = employees?.find(
                        (e: any) =>
                            normalize(`${e?.FirstName || ''} ${e?.LastName || ''}`) ===
                            normalize(row.reportingManager)
                    );


                    

                    const genderIdMap: Record<string, number> = {
                        male: 1,
                        female: 2,
                        other: 3,
                    };
                    const genderId = row.gender ? genderIdMap[row.gender.toLowerCase()] || null : null;

                    // --- Replace names with IDs if found ---
                    row.designation = designationObj?.DesignationId || null;
                    row.department = departmentObj?.Id || null;
                    row.employeeRole = roleObj?.RoleId || null;
                    row.branch = branchObj?.Id || null;
                    row.reportingManager = managerObj?.EmployeeID || null;
                    row.gender = genderId;
                    // --- Validation checks ---
                    if (!row.firstName || !row.lastName) validationErrors.push("Missing name.");
                    if (!row.email || !/^\S+@\S+\.\S+$/.test(row.email)) validationErrors.push("Invalid email.");
                    if (!row.password) validationErrors.push("Password required.");
                    if (isNaN(Date.parse(row.dateOfBirth))) validationErrors.push("Invalid DOB.");
                    if (!row.gender) validationErrors.push("Invalid gender (use Male/Female/Other).");
                    if (!row.designation) validationErrors.push("Invalid designation name.");
                    if (!row.department) validationErrors.push("Invalid department name.");
                    if (isNaN(Date.parse(row.joiningDate))) validationErrors.push("Invalid joining date.");
                    if (!/^\d{10}$/.test(row.phoneNumber)) validationErrors.push("Invalid phone number.");
                    // if (!row.reportingManager) validationErrors.push("Invalid reporting manager name.");
                    if (!row.company) validationErrors.push("Company required.");
                    if (!row.employeeRole) validationErrors.push("Invalid role name.");
                    if (
                        !['Full-time', 'Part-time', 'Contract', 'Freelance', 'Internship'].includes(row.employmentType)
                    )
                        validationErrors.push("Invalid employment type.");
                    if (!['Remote', 'Client-side', 'Work from Office'].includes(row.workPreference))
                        validationErrors.push("Invalid work preference.");
                    if (!['Active', 'Inactive'].includes(row.employee_status))
                        validationErrors.push("Invalid status.");
                    if (![0, 1].includes(+row.pfEnable))
                        validationErrors.push("PF Enable must be 0 or 1.");
                    if (!row.branch) validationErrors.push("Invalid branch name.");
                    if (!row.job_location) validationErrors.push("Job location required.");
                    if (!row.BankAccountForPayroll || row.BankAccountForPayroll.length < 6)
                        validationErrors.push("Invalid Account Number");
                    if (!row.BankIfscForPayroll || row.BankIfscForPayroll.length < 5)
                        validationErrors.push("Invalid IFSC");
                    if (!row.BankNameForPayroll || row.BankNameForPayroll.trim() === '')
                        validationErrors.push("Bank name is required");
                    if (!row.BankBranchAddress || row.BankBranchAddress.trim() === '')
                        validationErrors.push("Branch address is required");

                    if (validationErrors.length) {
                        message.warning(`Skipping ${row.email || 'entry'}: ${validationErrors.join(', ')}`);
                        invalidCount++;
                        continue;
                    }

                    const employeeData = mapCSVRowToEmployee(row);
                    try {
                        const result = await dispatch(createEmployee(employeeData));
                        if (createEmployee.rejected.match(result)) {
                            const errorMsg =
                                typeof result.payload === 'string'
                                    ? result.payload
                                    : 'Failed to import employee';
                            message.error(errorMsg);
                            invalidCount++;
                        } else {
                            validCount++;
                            const employeeId = result.payload?.data.EmployeeId;
                            if (employeeId) {
                                const bankPayload = {
                                    BankAccountForPayroll: row.BankAccountForPayroll || '',
                                    BankNameForPayroll: row.BankNameForPayroll || '',
                                    BankIfscForPayroll: row.BankIfscForPayroll || '',
                                    BankBranchAddress: row.BankBranchAddress || '',
                                };
                                const hasBankDetails = Object.values(bankPayload).every((v) => !!v.trim());
                                if (hasBankDetails) {
                                    const bankResult = await dispatch(
                                        updateBankDetails({ employeeId, bankDetails: bankPayload })
                                    );
                                    if (updateBankDetails.rejected.match(bankResult)) {
                                        message.warning(
                                            `Employee created but failed to update bank details for ${row.email}`
                                        );
                                    }
                                }
                            }
                        }
                    } catch (error) {
                        message.error('Unexpected error while creating employee.');
                        invalidCount++;
                    }
                }


                await dispatch(getEmployees());
                setTableKey((prev) => prev + 1);

                message.success({
                    content: `Imported: ${validCount}, Skipped: ${invalidCount}`,
                    key: 'import',
                    duration: 4,
                });
            },
        });
    };

    const mapCSVRowToEmployee = (row: any) => {
        return {
            Name: `${row.firstName} ${row.lastName}`,
            Email: row.email,
            FirstName: row.firstName,
            LastName: row.lastName,
            UserId: 0,
            password: row.password,
            DateOfBirth: dayjs(row.dateOfBirth).format('YYYY-MM-DD'),
            GenderId: row.gender,
            DesignationId: row.designation,
            DepartmentId: row.department,
            DateOfJoining: dayjs(row.joiningDate).format('YYYY-MM-DD'),
            mobile: row.phoneNumber,
            ModifiedBy: 1,
            Description: row.about,
            SupervisorId: row.reportingManager || 0,
            profilePicture: null,
            Company: row.company,
            RoleId: row.employeeRole,
            employmentType: row.employmentType,
            workPreference: row.workPreference,
            employee_status: row.employee_status,
            pfEnable: row.pfEnable,
            branch: row.branch,
            job_location: row.job_location,
            BankAccountForPayroll: row.BankAccount || '',
            BankNameForPayroll: row.BankName || '',
            BankIfscForPayroll: row.BankIfsc || '',
            BankBranchAddress: row.BankBranchAddress || '',
            maxUser: user?.total_user
        };
    };

    return {
        handleCSVImport
    };
};
